import Vue from 'vue';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import '@/assets/css/customize.css';
import router from '@/router/index';
import webapi from '@/webapi/index';
import App from './App.vue';

Vue.config.productionTip = false;

Vue.use(Antd);
Vue.prototype.$api = webapi;

Vue.prototype.$bus = new Vue();

new Vue({
  render: h => h(App),
  router,
}).$mount('#app');
